// extracted by mini-css-extract-plugin
module.exports = {"promo":"ProductPromo_promo__k8gaA","uppercasedTag":"ProductPromo_uppercasedTag__Ox4TR","promoRange":"ProductPromo_promoRange__1UkzU"};